module.exports = __webpack_public_path__ + "img/t5.c1f2c1b7.png";